import { useEffect, useState } from 'react'

import { Invoice, Product } from '@infura/packages.api'

import useSubscription from 'hooks/useSubscription'

import { useApi } from 'lib/api/api'

// Adjust import paths as necessary

const useOutstandingInvoices = () => {
  const { loading: subscriptionLoading, subscription } = useSubscription()
  const { data: invoices, isLoading: invoicesLoading } = useApi(['getInvoices', 1, 200, Product.ETHEREUM])
  const [openInvoices, setOpenInvoices] = useState<Array<Invoice>>([])

  useEffect(() => {
    if (!subscriptionLoading && !invoicesLoading && subscription?.state === 'past_due' && invoices?.data?.invoices) {
      const filteredInvoices = invoices.data.invoices.filter(invoice => invoice.status === 'open')
      setOpenInvoices(filteredInvoices)
    }
  }, [subscription, invoices, subscriptionLoading, invoicesLoading])

  return { loading: subscriptionLoading || invoicesLoading, openInvoices }
}

export default useOutstandingInvoices
